// Mutations do slice `chat` (spec-003 G6). Re-exportadas por store/mutations.js.
// Prefixo CHAT_ evita colisão com as mutations da spec-002 (SET_CATALOG, etc.).
// Todas mutam `state.chat.*` — as propriedades já existem no state inicial (reatividade Vue 2).

export const CHAT_SET_AGENTS = (state, payload) => {
  state.chat.agents = payload || []
}
export const CHAT_SET_LOADING_AGENTS = (state, payload) => {
  state.chat.loadingAgents = payload
}
export const CHAT_SET_MODULE_FORBIDDEN = (state, payload) => {
  state.chat.moduleForbidden = payload
}
export const CHAT_SET_SELECTED_AGENT = (state, idInstance) => {
  state.chat.selectedAgentId = idInstance
}

export const CHAT_SET_CONVERSATIONS = (state, payload) => {
  state.chat.conversations = payload || []
}
export const CHAT_SET_LOADING_CONVERSATIONS = (state, payload) => {
  state.chat.loadingConversations = payload
}
export const CHAT_SET_SELECTED_CONVERSATION = (state, id) => {
  state.chat.selectedConversationId = id
}
export const CHAT_UPDATE_CONVERSATION_TOPIC = (state, payload) => {
  const id = payload.id
  const topic = payload.topic
  state.chat.conversations = state.chat.conversations.map((c) =>
    c.id === id ? { ...c, topic: topic } : c
  )
}

export const CHAT_SET_MESSAGES = (state, payload) => {
  state.chat.messages = payload || []
}
export const CHAT_ADD_MESSAGE = (state, payload) => {
  state.chat.messages = state.chat.messages.concat([payload])
}
export const CHAT_SET_LOADING_MESSAGES = (state, payload) => {
  state.chat.loadingMessages = payload
}

export const CHAT_SET_STREAMING = (state, payload) => {
  state.chat.streaming = payload
}
export const CHAT_APPEND_RESPONSE_TOKEN = (state, token) => {
  state.chat.responseTokens = state.chat.responseTokens.concat([token])
}
export const CHAT_RESET_RESPONSE_TOKENS = (state) => {
  state.chat.responseTokens = []
}
export const CHAT_ADD_THINKING_STEP = (state, step) => {
  state.chat.thinkingSteps = state.chat.thinkingSteps.concat([step])
}
export const CHAT_RESET_THINKING_STEPS = (state) => {
  state.chat.thinkingSteps = []
}
export const CHAT_ADD_TOOL_CALL = (state, toolName) => {
  state.chat.activeToolCalls = state.chat.activeToolCalls.concat([toolName])
}
export const CHAT_REMOVE_TOOL_CALL = (state, toolName) => {
  state.chat.activeToolCalls = state.chat.activeToolCalls.filter((t) => t !== toolName)
}
export const CHAT_RESET_TOOL_CALLS = (state) => {
  state.chat.activeToolCalls = []
}

export const CHAT_SET_RUN_ID = (state, id) => {
  state.chat.currentRunId = id
}
export const CHAT_SET_PENDING_PROPOSALS = (state, payload) => {
  state.chat.pendingProposals = payload || []
}
export const CHAT_ADD_PENDING_PROPOSAL = (state, proposal) => {
  state.chat.pendingProposals = state.chat.pendingProposals.concat([proposal])
}
export const CHAT_RESET_PENDING_PROPOSALS = (state) => {
  state.chat.pendingProposals = []
}

export const CHAT_ADD_SYSTEM_MESSAGE = (state, payload) => {
  state.chat.systemMessages = state.chat.systemMessages.concat([payload])
}
export const CHAT_RESET_SYSTEM_MESSAGES = (state) => {
  state.chat.systemMessages = []
}
